"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "montabone": {
    "7e465172": [{
      "hkey": "4dd3935d",
      "slug": "montabone",
      "name": "Montabone",
      "primary": true,
      "skipSearch": false
    }],
    "ferraris": [{
      "hkey": "4dd3935d",
      "slug": "montabone",
      "name": "Montabone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "99cb17ee": [{
      "hkey": "4dd3935d",
      "slug": "montabone",
      "name": "Montabone",
      "primary": true,
      "skipSearch": false
    }],
    "girini": [{
      "hkey": "4dd3935d",
      "slug": "montabone",
      "name": "Montabone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3a3fd4c6": [{
      "hkey": "4dd3935d",
      "slug": "montabone",
      "name": "Montabone",
      "primary": true,
      "skipSearch": false
    }],
    "lacana": [{
      "hkey": "4dd3935d",
      "slug": "montabone",
      "name": "Montabone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;